/* eslint-disable react-hooks/rules-of-hooks */
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { KEY_WORD, fileExtension, fileType, COOKIES_LIST } from './constant';
import CryptoJS from 'crypto-js';
import moment from 'moment';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import qs from 'qs';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
export const secretKey = 'democlient:democlientsecret';
export const encryptKey = 'y347t567t347InCrUiTeRb6t5b3487y5';
export const isUpperCase = (value) => /[A-Z]/.test(value);
export const isLowerCase = (value) => /[a-z]/.test(value);
export const isContainNumber = (value) => /\d/.test(value);
export const isSpecialChar = (value) => /[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]+/.test(value);

export const getLocalStorageItem = (key) => localStorage.getItem(key);
export const setLocalStorageItem = (key, value) => localStorage.setItem(key, value);
export const removeLocalStorageItem = (key) => localStorage.removeItem(key);
const envMode = process.env.REACT_APP_ENV === 'dev2' ? 'dev' : process.env.REACT_APP_ENV;
export const convertIntoQueryString = (data) => {
    return qs.stringify(data);
};

export const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds} mins`;
};

/** Psychometric: questions per skill = (duration in minutes / 3) × 2 */
export const getPsychometricQuestionsPerSkill = (durationSeconds) => {
    const durationMinutes = Number(durationSeconds || 0) / 60;
    if (!durationMinutes) return 0;
    return Math.round((durationMinutes / 3) * 2);
};

export const getPsychometricTotalQuestionCount = (skills = []) => {
    if (!Array.isArray(skills) || skills.length === 0) return 0;
    return skills.reduce((total, skill) => total + getPsychometricQuestionsPerSkill(skill?.duration), 0);
};

export const getTenantId = () => Cookies.get('tenantId') ?? '';

export const useWindowSize = () => {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
};

export const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const capitalizeAll = (s) => {
    if (typeof s !== 'string') return '';
    return s
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
export const useOutsideAlerter = (ref, setIsOpen) => {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, setIsOpen]);
};

export const newUseOutsideAlerter = (ref, callback) => {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]);
};

export const Toast = ({ msg }) => <>{msg}</>;

export const toastMessage = (type, message) => {
    toast[type](message, { autoClose: '5000', toastId: message });
};

export const getYearsFrom1900ToCurrentYear = () => {
    const date = new Date();
    const currentYear = date.getFullYear();
    const totalYear = currentYear - 1900;
    const year = [];
    for (let i = totalYear; i >= 0; i--) {
        year.push(currentYear - i);
    }
    return year;
};
const date = new Date();
const year = date.toISOString().split('-')[0];
const month = date.toISOString().split('-')[1];
export const graphDropDownInterviewMonthsOption = [
    {
        value: `&from=2013-01-01T00:00:00.000Z&to=${year}-${month}-31T23:59:59.000Z`,
        label: 'All',
    },
    {
        value: `&from=${year}-01-01T00:00:00.000Z&to=${year}-01-31T23:59:59.000Z`,
        label: 'Jan',
    },
    {
        value: `&from=${year}-02-01T00:00:00.000Z&to=${year}-02-28T23:59:59.000Z`,
        label: 'Feb',
    },
    {
        value: `&from=${year}-03-01T00:00:00.000Z&to=${year}-03-31T23:59:59.000Z`,
        label: 'Mar',
    },
    {
        value: `&from=${year}-04-01T00:00:00.000Z&to=${year}-04-30T23:59:59.000Z`,
        label: 'Apr',
    },
    {
        value: `&from=${year}-05-01T00:00:00.000Z&to=${year}-05-31T23:59:59.000Z`,
        label: 'May',
    },
    {
        value: `&from=${year}-06-01T00:00:00.000Z&to=${year}-06-30T23:59:59.000Z`,
        label: 'Jun',
    },
    {
        value: `&from=${year}-07-01T00:00:00.000Z&to=${year}-07-31T23:59:59.000Z`,
        label: 'Jul',
    },
    {
        value: `&from=${year}-08-01T00:00:00.000Z&to=${year}-08-31T23:59:59.000Z`,
        label: 'Aug',
    },
    {
        value: `&from=${year}-09-01T00:00:00.000Z&to=${year}-09-30T23:59:59.000Z`,
        label: 'Sep',
    },
    {
        value: `&from=${year}-010-01T00:00:00.000Z&to=${year}-10-31T23:59:59.000Z`,
        label: 'Oct',
    },
    {
        value: `&from=${year}-011-01T00:00:00.000Z&to=${year}-11-30T23:59:59.000Z`,
        label: 'Nov',
    },
    {
        value: `&from=${year}-12-01T00:00:00.000Z&to=${year}-12-31T23:59:59.000Z`,
        label: 'Dec',
    },
];
export const TimeRangeOptions = [
    {
        label: 'Today',
        value: {
            from: moment().format('YYYY-MM-DDT00:00:00.000Z'),
            to: moment().format('YYYY-MM-DDT23:59:59.000Z'),
        },
    },
    {
        label: 'Yesterday',
        value: {
            from: moment().subtract(1, 'days').format('YYYY-MM-DDT00:00:00.000Z'),
            to: moment().subtract(1, 'days').format('YYYY-MM-DDT23:59:59.000Z'),
        },
    },
    {
        label: 'Last 7 Days',
        value: {
            from: moment().subtract(7, 'days').format('YYYY-MM-DDT00:00:00.000Z'),
            to: moment().format('YYYY-MM-DDT23:59:59.000Z'),
        },
    },
    {
        label: 'Last 30 Days',
        value: {
            from: moment().subtract(30, 'days').format('YYYY-MM-DDT00:00:00.000Z'),
            to: moment().format('YYYY-MM-DDT23:59:59.000Z'),
        },
    },
    {
        label: 'All',
        value: {
            from: moment().subtract(10, 'years').format('YYYY-MM-DDT00:00:00.000Z'),
            to: moment().format('YYYY-MM-DDT23:59:59.000Z'),
        },
    },
];
export const getOptions = (data) => {
    const newArray = [];
    data.forEach((element) =>
        newArray.push({
            value: element,
            label: element,
        })
    );
    return newArray;
};

export const localStorageName = [
    { key: 'token', value: 'iCtK' },
    { key: 'viewtype', value: 'viewType' },
    { key: 'refreshToken', value: 'iCrT' },
    { key: 'incserveToken', value: 'iCiT' },
    { key: 'incserveTokenKey', value: 'iCiTi' },
    { key: 'userData', value: `iCuD_${envMode}` },
    { key: 'companyData', value: `iCcD_${envMode}` },
    { key: 'productId', value: `iCpD_${envMode}` },
    { key: 'permissions', value: `ic_p_${envMode}` },
    { key: 'credit', value: 'iCcR' },
    { key: 'expiryTime', value: 'iCeT' },
    { key: 'feedbackReport', value: 'iCfd' },
    { key: 'interviewData', value: 'intDat' },
];

// Builds the Candidate Bank excel rows (default fields + configured custom fields).
// Shared by every Candidate Bank export entry point so all of them produce the same dataset.
export const buildCandidateBankExportList = (list) => {
    const exportList = [];
    const customFieldMap = {};

    list?.forEach((data) => {
        data?.customFields?.forEach((field) => {
            if (field?.fieldName) {
                // [2026-09-18] CHANGED - was `${field.fieldName} *` for a mandatory field. The asterisk
                // marks "required" on screen; as a spreadsheet header it reads as part of the column
                // name ("Email *"), so the export uses the plain name.
                customFieldMap[field.fieldName] = field.fieldName;
            }
        });
    });

    list?.forEach((data) => {
        if (data?.status === 'Deleted') return;

        const baseData = {
            'Serial No': exportList.length + 1,
            'Candidate Name': data?.name || 'N/A',
            'Candidate Mail': data?.email || 'N/A',
            'WhatsApp Number': data?.phone || 'N/A',
            Resume: data?.resumeUrl || 'N/A',
            Status: data?.status || 'N/A',
        };

        // Initialize all custom fields with empty string so every row carries the same columns
        Object.keys(customFieldMap).forEach((fieldName) => {
            baseData[customFieldMap[fieldName]] = '';
        });

        // Fill in candidate's custom field values
        data?.customFields?.forEach((field) => {
            const columnName = customFieldMap[field?.fieldName];
            if (columnName) {
                baseData[columnName] = field?.values !== undefined && field?.values !== '' ? field.values : 'N/A';
            }
        });

        exportList.push(baseData);
    });

    return exportList;
};

export const exportToCSV = (apiData, fileName) => {
    if (apiData?.length > 0) {
        const objectMaxLength = [];
        const wscols = [];
        for (let i = 0; i < apiData.length; i++) {
            let value = Object.values(apiData[i]);
            for (let j = 0; j < value.length; j++) {
                if (typeof value[j] === 'number') {
                    objectMaxLength[j] = 10;
                } else {
                    objectMaxLength[j] = objectMaxLength[j] >= value[j]?.length ? objectMaxLength[j] : value[j]?.length;
                }
            }
        }
        for (let i = 0; i < Object.keys(apiData[0]).length; i++) {
            wscols.push({ width: objectMaxLength[i] });
        }

        const ws = XLSX.utils.json_to_sheet(apiData);
        ws['!cols'] = wscols;
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    } else {
        toast.error('No Record to Export', {
            autoClose: 5000,
            toastId: 'No Record to Export',
        });
    }
};

export const downloadFile = async (fileUrl, fileName, containerSasToken = null) => {
    try {
        const response = await fetch(containerSasToken ? fileUrl + '?' + containerSasToken : fileUrl);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        let a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error downloading the file:', error);
    }
};

export const accessRoutes = (resource) => {
    let userType = localStorageJsonParseDecrypt('userData') && localStorageJsonParseDecrypt('userData').userType;
    let permissions = localStorageJsonParseDecrypt('permissions');
    permissions = permissions && permissions.filter((itm) => itm.name === resource);
    if (permissions[0]?.status === 'active' || userType === 'employer') {
        return true;
    } else {
        return false;
    }
};

export const checkResumeScoreThreshold = () => {
    const userType = localStorageJsonParseDecrypt('userData')?.userType;
    if (userType === 'employer') return true;

    const permissions = localStorageJsonParseDecrypt('permissions');
    const incBot = permissions?.find((itm) => itm?.key === 'incBot');
    const configuration = incBot?.resources?.find((itm) => itm?.key === 'configuration');
    const resumeScoreThreshold = configuration?.resources?.find((itm) => itm?.key === 'resume_score_threshold');
    return resumeScoreThreshold?.actions?.status === true;
};

export const checkRoutes = (resource) => {
    let userType = localStorageJsonParseDecrypt('userData') && localStorageJsonParseDecrypt('userData').userType;
    let permissions = localStorageJsonParseDecrypt('permissions');
    permissions = permissions && permissions.filter((itm) => itm.name === resource);
    if (permissions[0]?.status === 'active' || userType === 'employer') {
        return true;
    } else {
        return false;
    }
};

export const remarksChecker = (value) => {
    // Remove any characters that are not allowed, excluding new lines
    const sanitizedValue = value.replace(/[^A-Za-z0-9\s\n!@#$%&*()_\-+=\[\]{}\/?.,;:'"\/]/g, '');
    return sanitizedValue;
};

export const jobTitleChecker = (value) => {
    return value.replace(/[^A-Za-z0-9\s\#\(\)\@\!\*\.\+]/g, '');
};

export const filterJobTitleInput = (inputValue) => {
    const allowedPattern = /[A-Za-z0-9#./+|_()\-\s]/;
    return inputValue
        .split('')
        .filter((char) => allowedPattern.test(char))
        .join('');
};
// Search boxes: same allowlist as job titles, plus '@' so emails can be searched.
export const filterSearchInput = (inputValue) => inputValue.replace(/[^A-Za-z0-9#./+|_()\-\s@]/g, '');

// Rejects junk titles that pass the character filter, e.g. "# ( ) - _ + | . /"
export const validateJobTitle = (title) => {
    const value = (title || '').trim();
    const letterCount = (value.match(/[A-Za-z]/g) || []).length;
    const alphanumericCount = (value.match(/[A-Za-z0-9]/g) || []).length;
    const symbolCount = value.replace(/[A-Za-z0-9\s]/g, '').length;
    if (letterCount < 2) return 'Job Title must contain at least 2 letters';
    if (!/^[A-Za-z0-9.#(]/.test(value)) return 'Job Title must start with a letter or number';
    if (symbolCount > alphanumericCount) return 'Job Title cannot be made up mostly of special characters';
    return '';
};
export const jobTitleCheckerwithallchar = (value) => {
    return value;
};
export const redirectPermission = () => {
    localStorage.clear();
    clearCookies();
    window.location.replace(mainWebsite + '/employer/login');
};

const commonLocalStorageDecryptCondition = (storageKey, isJson) => {
    let Key = storageKey;
    localStorageName
        .filter((itm) => itm.key === storageKey)
        .map((itm) => {
            Key = itm.value;
        });
    var data = '';
    if (COOKIES_LIST.includes(storageKey)) {
        if (Cookies.get(Key)) {
            var bytes = CryptoJS.AES.decrypt(Cookies.get(Key), encryptKey);
            data = bytes.toString(CryptoJS.enc.Utf8);
            if (data && isJson) {
                data = JSON.parse(data);
            }
        }
    } else {
        if (getLocalStorageItem(Key)) {
            var bytes = CryptoJS.AES.decrypt(getLocalStorageItem(Key), encryptKey);
            data = bytes.toString(CryptoJS.enc.Utf8);
            if (data && isJson) {
                data = JSON.parse(data);
            }
        }
    }
    return data;
};

/**
 * Get secure cookie options for js-cookie library
 *
 * Note: js-cookie (v3.0.5) does NOT support `maxAge` - only `expires`
 * - expires: Number (days from now) OR Date object (absolute expiration)
 *
 * For backend cookies (Express/Fastify), use `maxAge` in milliseconds:
 * { httpOnly: true, secure: true, sameSite: 'Strict', maxAge: 24 * 60 * 60 * 1000 }
 */
const getSecureCookieOptions = () => {
    const isLocalhost = window.location.hostname === KEY_WORD?.LOCALHOST;
    const isSecure = window.location.protocol === 'https:';

    return {
        domain: isLocalhost ? KEY_WORD?.LOCALHOST : KEY_WORD?.INCRUITER_DOMAIN,
        path: '/',
        secure: isSecure, // Only set secure flag on HTTPS connections
        sameSite: 'Strict', // Prevent CSRF and session hijacking
        expires: 1, // 1 day - js-cookie uses expires (Number = days), NOT maxAge
    };
};

export const localStorageEncrypt = (storageKey, data) => {
    let Key = storageKey;
    localStorageName
        .filter((itm) => itm.key === storageKey)
        .map((itm) => {
            Key = itm.value;
        });
    var value = CryptoJS.AES.encrypt(data, encryptKey).toString();
    if (COOKIES_LIST.includes(storageKey)) {
        Cookies.set(Key, value, getSecureCookieOptions());
    } else {
        setLocalStorageItem(Key, value);
    }
};

export const localStorageDecrypt = (storageKey) => {
    return commonLocalStorageDecryptCondition(storageKey, false);
};

export const localStorageJsonParseDecrypt = (storageKey) => {
    return commonLocalStorageDecryptCondition(storageKey, true);
};

export const localStorageRemove = (storageKey) => {
    let Key = storageKey;
    localStorageName
        .filter((itm) => itm.key === storageKey)
        .map((itm) => {
            Key = itm.value;
        });
    if (COOKIES_LIST.includes(Key)) {
        Cookies.remove(Key, getSecureCookieOptions());
    } else {
        localStorage.removeItem(Key);
    }
};

export const ArrayForExpRange = () => {
    const tmpArray = [];
    Array.from({ length: 41 }, (_, index) => index).map((itm) => {
        tmpArray.push({
            value: itm,
            label: itm,
        });
    });
    return tmpArray;
};
export const jobTypeOptions = [
    {
        value: 'Full-time',
        label: 'Full-time',
    },
    {
        value: 'Part-time',
        label: 'Part-time',
    },
    {
        value: 'Contract',
        label: 'Contract',
    },
    {
        value: 'Internship',
        label: 'Internship',
    },
];

export const salaryRangeOptions = [
    {
        value: '0 - 3 Lakhs',
        label: '0 - 3 Lakhs',
    },
    {
        value: '3 - 6 Lakhs',
        label: '3 - 6 Lakhs',
    },
    {
        value: '6 - 10 Lakhs',
        label: '6 - 10 Lakhs',
    },
    {
        value: '10 - 15 Lakhs',
        label: '10 - 15 Lakhs',
    },
    {
        value: '15 - 25 Lakhs',
        label: '15 - 25 Lakhs',
    },
    {
        value: '25 - 50 Lakhs',
        label: '25 - 50 Lakhs',
    },
    {
        value: '50 - 75 Lakhs',
        label: '50 - 75 Lakhs',
    },
    {
        value: '75 - 100 Lakhs',
        label: '75 - 100 Lakhs',
    },
    {
        value: '1 - 5 Cr',
        label: '1 - 5 Cr',
    },
];
export const skillChecker = (value) => {
    return value.replace(/[^A-Za-z0-9\s\,\(\)\!\@\*\.\-\+\#]/g, '');
};
export const numberChecker = (value) => {
    return value.replace(/\D/g, '');
};
export const nameChecker = (value) => {
    const modifiedValue = value.replace(/[^A-Za-z\s\.]/g, '');
    if (modifiedValue.length > 80) {
        return modifiedValue.slice(0, 80);
    }
    return modifiedValue;
};

export const reload = () => {
    return window.location.reload();
};
export const mailChecker = (value) => {
    return value.replace(/[^a-zA-Z0-9\_\-\@\.\+]/g, '');
};
export const contactNumberChecker = (value) => {
    return value.replace(/[^0-9]/g, '').slice(0, 10);
};

export const validateEmail = (email) => {
    const regex =
        /^(?!\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.(?:com|gov|org|edu|net|in|co(?:\.[a-zA-Z]{2})?))$/;

    return regex.test(email);
};

export const notificationRedirect = (data, navigate) => {
    const getPath = (productName, itemType) => {
        const itemTypeLower = itemType?.toUpperCase()?.trim();
        switch (itemTypeLower) {
            case 'INTERVIEWS':
                if (productName?.toLowerCase() === KEY_WORD.INCBOT) return '/candidates';
                return '/my-interviews';
            case 'QUESTIONS':
                return '/positions';
            case 'POSITIONS':
                return '/positions';
            case 'CANDIDATEBANK':
                if (productName?.toLowerCase() === KEY_WORD.INCBOT) return '/candidate-bank';
            case 'SUPPORT':
                return '/support';
            case 'PANELISTS':
                return '/create-panelist';
            case 'ROLES':
                return '/roles-subuser-list?role';
            case 'SUBUSERS':
                return '/roles-subuser-list';
            default:
                return '';
        }
    };
    const getOperator = (urlPath) => {
        return urlPath.includes('?') ? '&' : '?';
    };
    const search = data?.data?.search;
    const itemType = data?.data?.itemType;
    const urlPath = getPath(data?.productId?.name, itemType);
    if (urlPath) {
        const productName = data.productId?.name;
        if (data?.data?.itemType && productName?.toLowerCase() === KEY_WORD?.INCBOT?.toLowerCase())
            navigate(urlPath + `${getOperator(urlPath)}search=${encodeURIComponent(search)}`);
        else window.location.href = `${generateUrl('account')}${urlPath}?search=${encodeURIComponent(search)}`;
    }
};

export const hasPageAccess = (permissions, mainResource, resourceName, action) => {
    const userType = localStorageJsonParseDecrypt('userData')?.userType;

    if (userType === 'employer') {
        return true;
    }

    if (mainResource === '') {
        return true;
    }

    const mainResourcePermission = permissions?.find(
        (permission) => permission?.key?.toLowerCase() === mainResource?.toLowerCase()
    );

    if (mainResourcePermission?.status) {
        const resourcePermission = mainResourcePermission?.resources?.find(
            (resource) => resource?.key?.toLowerCase() === resourceName?.toLowerCase()
        );
        if (resourcePermission?.actions?.hasOwnProperty('status')) {
            return resourcePermission?.actions?.status;
        } else {
            return resourcePermission?.actions[action];
        }
    } else {
        return false;
    }
};

export const hasProductAccess = (permissions, mainResourceName) => {
    const userType = localStorageJsonParseDecrypt('userData')?.userType;

    if (mainResourceName === 'incserve' || userType === 'employer') {
        return true;
    }

    const resourcePermission = permissions?.find(
        (permission) => permission?.name && permission?.name.toLowerCase() === mainResourceName?.toLowerCase()
    );

    return resourcePermission?.status || false;
};

export const hasActionAccess = (permissions, mainResource, resourceName, action) => {
    const userType = localStorageJsonParseDecrypt('userData')?.userType;

    if (userType === 'employer') {
        return true;
    }

    if (mainResource === '') {
        return true;
    }

    const mainResourcePermission = permissions?.find(
        (permission) => permission?.key?.toLowerCase() === mainResource?.toLowerCase()
    );

    const resourcePermission = mainResourcePermission?.resources?.find(
        (resource) => resource?.key?.toLowerCase() === resourceName?.toLowerCase()
    );

    if (resourcePermission?.actions?.hasOwnProperty('status')) {
        return resourcePermission?.actions?.status;
    } else if (resourcePermission?.actions) {
        return resourcePermission?.actions[action];
    }

    return false;
};

export const commonPageList = [
    '/my-profile',
    '/accounts-billing',
    '/settings',
    '/subuser',
    '/contact-enquiries',
    '/roles',
    '/roles-subuser-list',
    '/product',
    '/plan-pricing',
    '/payment-information',
    '/payment-success',
    '/notification',
];
export const generateUrl = (urlMode) => {
    const envMode = process.env.REACT_APP_ENV;
    let frontendUrlPreFix, backendUrlPreFix, externalUrl, interviewUrlPreFix;
    let finalUrl;
    if (envMode === 'prod') {
        interviewUrlPreFix = 'meeting';
        frontendUrlPreFix = '';
        backendUrlPreFix = 'api.';
        externalUrl = '';
    } else if (envMode === 'test' || envMode === 'preprod') {
        interviewUrlPreFix = 'test.v1.interview';
        frontendUrlPreFix = 'test.v1.';
        backendUrlPreFix = 'test.api.';
        externalUrl = 'preprod.';
    } else if (envMode === 'dev2') {
        interviewUrlPreFix = 'dev.v2.interview';
        frontendUrlPreFix = 'dev.v2.';
        backendUrlPreFix = 'dev.v2.api.';
        externalUrl = 'dev.';
    } else {
        interviewUrlPreFix = 'dev.v1.interview';
        frontendUrlPreFix = 'dev.v1.';
        backendUrlPreFix = 'dev.api.';
        externalUrl = 'dev.';
    }
    if (urlMode === 'incserve') {
        finalUrl = `https://${externalUrl}incserve.incruiter.com`;
    } else if (urlMode === 'website') {
        finalUrl = `https://${frontendUrlPreFix}incruiter.com`;
    } else if (urlMode === 'account') {
        finalUrl = `https://${frontendUrlPreFix}account.incruiter.com`;
    } else if (urlMode === 'incscreen') {
        finalUrl = `https://${frontendUrlPreFix}incscreen.incruiter.com`;
    } else if (urlMode === 'workflow') {
        finalUrl = `https://${frontendUrlPreFix}workflow.incruiter.com`;
    } else if (urlMode === 'incbot') {
        finalUrl = `https://${frontendUrlPreFix}incbot.incruiter.com`;
    } else if (urlMode === 'job_board') {
        finalUrl = `https://${frontendUrlPreFix}jobs.incruiter.com`;
    } else if (urlMode === 'career_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/candidate-listing-system/api/v1`;
    } else if (urlMode === 'interview_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/interview-system/api/v1`;
    } else if (urlMode === 'incbot_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/incbot-video-system/incbot`;
    } else if (urlMode === 'skills_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/skills-system/api/v1`;
    } else if (urlMode === 'user_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/user-auth-system/api/v1`;
        // finalUrl = `http://10.1.0.56:4001/api/v1`;
    } else if (urlMode === 'calendar_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/calendar-system/api/v1`;
    } else if (urlMode === 'subscription_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/subscription-system/api/v1`;
    } else if (urlMode === 'video_backend') {
        finalUrl = `https://${backendUrlPreFix}incruiter.com/video-feedback-system/api/v1`;
    } else if (urlMode === 'meeting') {
        finalUrl = `https://${interviewUrlPreFix}.incruiter.com/interview`;
    } else if (urlMode === 'incproctor') {
        // Not the prefix pattern: prod is incproctor.incruiter.com, test is test.v1.proctor.incruiter.com.
        // Same table as frontend-account's generateUrl.
        const proctorHosts = {
            prod: 'https://incproctor.incruiter.com',
            test: 'https://test.v1.proctor.incruiter.com',
            preprod: 'https://test.v1.proctor.incruiter.com',
        };
        finalUrl = process.env.REACT_APP_PROCTOR_URL || proctorHosts[envMode] || 'https://dev.v1.proctor.incruiter.com';
    }
    return finalUrl;
};
export const url = generateUrl('user_backend');
export const incserveUrl = generateUrl('incserve');
export const mainWebsite = generateUrl('website');
export const incserveStagingUrl = generateUrl('incserve');
export const getAssetSrc = (assetName) => {
    return `https://incruiter.blob.core.windows.net/frontend/frontend-incbot/assets/${assetName}`;
};

export const getIncserveToken = Cookies.get(`incserveToken_${envMode}`) ?? '';

// A FRESH read of the same cookie, as a function. `getIncserveToken` above is a module-level
// const, so it is evaluated EXACTLY ONCE, when this module is first imported — i.e. at page load.
// Every consumer of it is really reading "was there an InCServe cookie when the tab opened", not
// "is there one now". If the cookie arrives, is refreshed, or expires afterwards, nothing notices
// until a full reload. Deliberately additive: the const is left exactly as it was so existing
// callers are untouched, and new call sites use this.
export const getIncserveTokenNow = () => Cookies.get(`incserveToken_${envMode}`) ?? '';
export const getAccessToken = Cookies.get(`token_${envMode}`) ?? '';

export const clearCookies = () => {
    const cookieNames = ['token', 'incserveToken', 'iCuD', 'iCcD', 'iCpD', 'ic_p'];
    cookieNames.forEach((name) => {
        Cookies.remove(`${name}_${envMode}`, getSecureCookieOptions());
    });
};

export const clearOldCookies = () => {
    let cookieNames = [];
    const cookiesDevName = [
        'token_dev',
        'incserveToken_dev',
        'iCuD_dev',
        'iCcD_dev',
        'iCpD_dev',
        'ic_p_dev',
        'incD_dev',
    ];
    const cookiesTestName = [
        'token_test',
        'incserveToken_test',
        'iCuD_test',
        'iCcD_test',
        'iCpD_test',
        'ic_p_test',
        'incD_test',
    ];
    const cookiesProdName = [
        'token_prod',
        'incserveToken_prod',
        'iCuD_prod',
        'iCcD_prod',
        'iCpD_prod',
        'ic_p_prod',
        'incD_prod',
    ];
    if (envMode === 'dev') {
        cookieNames = [...cookiesTestName, ...cookiesProdName];
    } else if (envMode === 'test') {
        cookieNames = [...cookiesDevName, ...cookiesProdName];
    } else {
        cookieNames = [...cookiesTestName, ...cookiesDevName];
    }
    cookieNames.forEach((name) => Cookies.remove(`${name}_${envMode}`, getSecureCookieOptions()));
};

export const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};

export const shareOnWhatsApp = (jobLink) => {
    const url = `https://wa.me/?text=${encodeURIComponent(jobLink)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
};

export const shareOnLinkedIn = (jobLink) => {
    const linkedinShareURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(jobLink)}`;
    window.open(linkedinShareURL, '_blank', 'noopener,noreferrer');
};

export const shareOnFacebook = (jobLink) => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(jobLink)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
};

export const shareOnTwitter = (jobLink) => {
    const url = `https://twitter.com/intent/tweet?text=Check out this job opportunity&url=${encodeURIComponent(jobLink)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
};

export const copyToClipboard = (jobLink) => {
    navigator.clipboard
        .writeText(jobLink)
        .then(() => {
            toast.success(<Toast msg="Link copied to clipboard." />, {
                autoClose: 2000,
                toastId: 'Link copied to clipboard.',
            });
        })
        .catch(() => {
            toast.error(<Toast msg="Unable to copy link. Please try again." />, {
                autoClose: 2000,
                toastId: 'Unable to copy link. Please try again.',
            });
        });
};

export const validateJsonBulkData = (data, questions) => {
    const maxQuestionLength = 750;
    const minQuestionLength = 10;
    const maxEntries = 250;

    if (!Array.isArray(data)) {
        return { valid: false, message: 'Data should be an array.' };
    }

    if (data.length > maxEntries) {
        return { valid: false, message: `Data exceeds the maximum limit of ${maxEntries} entries.` };
    }

    // Create a set of existing questions (trimmed) from the current question bank.
    const existingQuestionsSet = new Set(questions.map((q) => q?.question?.trim()));
    // Use a Map to keep track of new questions and their index in the bulk data.
    const newQuestionsMap = new Map();

    for (let i = 0; i < data.length; i++) {
        const entry = data[i];

        if (!entry.hasOwnProperty('questions') && !entry.hasOwnProperty('Questions')) {
            return { valid: false, message: `Entry ${i + 1} is missing the "question" key.` };
        }

        const questionText = (entry.questions || entry.Questions || '').trim();

        if (!questionText) {
            return { valid: false, message: `Entry ${i + 1} does not contain a valid question text.` };
        }

        if (existingQuestionsSet.has(questionText)) {
            return { valid: false, message: `Question ${i + 1} already exists.` };
        }

        if (newQuestionsMap.has(questionText)) {
            const firstIndex = newQuestionsMap.get(questionText); // Get the first occurrence index
            return {
                valid: false,
                message: `Duplicate question found at entries ${firstIndex + 1} and ${i + 1}.`,
            };
        }

        newQuestionsMap.set(questionText, i);

        if (questionText.length < minQuestionLength) {
            return {
                valid: false,
                message: `Question ${i + 1} is shorter than the minimum allowed length of ${minQuestionLength} characters.`,
            };
        }

        if (questionText.length > maxQuestionLength) {
            return {
                valid: false,
                message: `Question ${i + 1} exceeds the maximum allowed length of ${maxQuestionLength} characters.`,
            };
        }
    }

    return { valid: true, message: 'Validation passed.' };
};

export const validateJsonBulkMcqData = (data, questions) => {
    const maxQuestionLength = 750;
    const minQuestionLength = 10;
    const maxOptionLength = 200;
    const minOptionLength = 1;
    const maxEntries = 100;

    if (!Array.isArray(data)) {
        return { valid: false, message: 'Data should be an array.' };
    }

    if (data.length > maxEntries) {
        return { valid: false, message: `Data exceeds the maximum limit of ${maxEntries} entries.` };
    }

    const existingQuestionsSet = new Set(questions.map((q) => q?.question?.trim()));
    const newQuestionsMap = new Map();

    for (let i = 0; i < data.length; i++) {
        const entry = data[i];

        // Validate question
        if (!entry.hasOwnProperty('questions') && !entry.hasOwnProperty('Questions')) {
            return { valid: false, message: `Entry ${i + 1} is missing the "question" key.` };
        }

        const questionText = String(entry.questions || entry.Questions || '').trim();

        if (!questionText) {
            return { valid: false, message: `Entry ${i + 1} does not contain a valid question text.` };
        }

        if (existingQuestionsSet.has(questionText)) {
            return { valid: false, message: `Question ${i + 1} already exists.` };
        }

        if (newQuestionsMap.has(questionText)) {
            const firstIndex = newQuestionsMap.get(questionText);
            return {
                valid: false,
                message: `Duplicate question found at entries ${firstIndex + 1} and ${i + 1}.`,
            };
        }

        newQuestionsMap.set(questionText, i);

        if (questionText.length < minQuestionLength) {
            return {
                valid: false,
                message: `Question ${i + 1} is shorter than the minimum allowed length of ${minQuestionLength} characters.`,
            };
        }

        if (questionText.length > maxQuestionLength) {
            return {
                valid: false,
                message: `Question ${i + 1} exceeds the maximum allowed length of ${maxQuestionLength} characters.`,
            };
        }

        // Validate options
        const optionKeys = [
            ['Option 1', 'option 1'],
            ['Option 2', 'option 2'],
            ['Option 3', 'option 3'],
            ['Option 4', 'option 4'],
        ];
        const optionValues = [];

        for (let j = 0; j < optionKeys.length; j++) {
            const [key1, key2] = optionKeys[j];
            const optionNumber = j + 1;

            if (!entry.hasOwnProperty(key1) && !entry.hasOwnProperty(key2)) {
                return { valid: false, message: `Entry ${i + 1} is missing "Option ${optionNumber}" key.` };
            }

            const optionText = String(entry[key1] || entry[key2] || '').trim();

            if (!optionText) {
                return { valid: false, message: `Entry ${i + 1} has empty "Option ${optionNumber}".` };
            }

            if (optionText.length < minOptionLength) {
                return {
                    valid: false,
                    message: `Entry ${i + 1} "Option ${optionNumber}" is too short (minimum ${minOptionLength} character).`,
                };
            }

            if (optionText.length > maxOptionLength) {
                return {
                    valid: false,
                    message: `Entry ${i + 1} "Option ${optionNumber}" exceeds maximum length of ${maxOptionLength} characters.`,
                };
            }

            if (optionValues.includes(optionText)) {
                return { valid: false, message: `Entry ${i + 1} has duplicate options.` };
            }

            optionValues.push(optionText);
        }

        // Validate correct answer
        if (!entry.hasOwnProperty('answer') && !entry.hasOwnProperty('Answer')) {
            return { valid: false, message: `Entry ${i + 1} is missing "answer" key.` };
        }

        const correctAnswer = String(entry.answer || entry.Answer || '').trim();

        if (!correctAnswer || !['1', '2', '3', '4'].includes(correctAnswer)) {
            return {
                valid: false,
                message: `Entry ${i + 1} has invalid "answer". Must be 1, 2, 3, or 4.`,
            };
        }
    }

    return { valid: true, message: 'Validation passed.' };
};

export const formatSecondsToTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts = [];
    if (hrs) parts.push(`${hrs} hr${hrs > 1 ? 's' : ''}`);
    if (mins) parts.push(`${mins} min${mins > 1 ? 's' : ''}`);
    if (secs || (!hrs && !mins)) parts.push(`${secs} sec${secs > 1 ? 's' : ''}`);
    return parts.join(' ');
};

const DEFAULT_ERROR_MSG = 'Something went wrong. Please try again.';
const generateError = (msg) => ({ status: false, msg });

export const validateFile = async ({
    file,
    maxSizeMB = 5,
    allowedTypes = [],
    endpoint = '',
    emptyMsg = 'File is empty or undefined',
    sizeMsg = 'The file size exceeds the limit',
    typeMsg = 'Invalid file type',
    fallbackMsg = 'Invalid file. Please upload a valid file',
}) => {
    try {
        if (!file) return generateError(emptyMsg);
        if (file.size > maxSizeMB * 1024 * 1024) return generateError(sizeMsg);
        const allowedTypesArray = Array.isArray(allowedTypes)
            ? allowedTypes
            : allowedTypes.split(',').map((type) => type.trim());

        if (!allowedTypesArray.includes(file.type)) return generateError(typeMsg);

        const formData = new FormData();
        formData.append('file', file);

        const url = `${generateUrl('interview_backend')}/${endpoint}`;
        const response = await fetch(url, { method: 'POST', body: formData });
        const res = await response.json();

        return {
            status: res?.status ?? false,
            msg: res?.message || fallbackMsg,
        };
    } catch {
        return generateError(DEFAULT_ERROR_MSG);
    }
};

export const FILE_TYPES = {
    IMAGE: 'image/jpeg, image/png, image/jpg',
    ZIP: 'zip, application/octet-stream, application/zip, application/x-zip, application/x-zip-compressed',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    PDF_WORD: [
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/msword', // .doc
        'application/x-msword',
        'application/x-cfb',
        'application/vnd.ms-word.document.macroenabled.12',
    ].join(', '),
    DOCX_TXT: [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'text/plain', // .txt
    ].join(', '),
};

export const checkFileBlank = (file) =>
    validateFile({
        file,
        maxSizeMB: 5,
        allowedTypes: FILE_TYPES.PDF_WORD,
        endpoint: 'validateFile',
        emptyMsg: 'File is empty or undefined',
        sizeMsg: 'The file size exceeds the 5MB limit',
        typeMsg: 'Invalid file type. Only .pdf, .docx, .doc are allowed',
        fallbackMsg: 'Invalid file type. Please upload a valid file',
    });

export const checkDocxTxtBlank = (file) =>
    validateFile({
        file,
        maxSizeMB: 5,
        allowedTypes: FILE_TYPES.DOCX_TXT,
        endpoint: 'validateFile',
        emptyMsg: 'File is empty or undefined',
        sizeMsg: 'The file size exceeds the 5MB limit',
        typeMsg: 'Invalid file type. Only .docx, .txt are allowed',
        fallbackMsg: 'Invalid file type. Please upload a valid file',
    });

export const checkXLSXBlank = (file) =>
    validateFile({
        file,
        maxSizeMB: 100,
        allowedTypes: FILE_TYPES.XLSX,
        endpoint: 'validateXlsx',
        emptyMsg: 'XLSX file is empty or undefined',
        sizeMsg: 'The XLSX file size exceeds the 100MB limit',
        typeMsg: 'Invalid file type. Only .xlsx is allowed',
        fallbackMsg: 'Invalid XLSX file. Please upload a valid .xlsx file',
    });

export const checkZipBlank = (file) =>
    validateFile({
        file,
        maxSizeMB: 100,
        allowedTypes: FILE_TYPES.ZIP,
        endpoint: 'validateZip',
        emptyMsg: 'ZIP file is empty or undefined',
        sizeMsg: 'The ZIP file size exceeds the 100MB limit',
        typeMsg: 'Invalid file type. Only .zip is allowed',
        fallbackMsg: 'Invalid ZIP file. Please upload a valid .zip file',
    });

export const getInterviewTypeLabel = (interviewTypeObj = {}) => {
    if (interviewTypeObj?.interviewType === 'cefr_interview') return 'Language Assessment';
    if (interviewTypeObj.aiPersona && interviewTypeObj.fullyConversational) return 'Hiring Manager Persona';
    if (interviewTypeObj.fullyConversational) return 'Agentic Conversational';
    if (interviewTypeObj.conversationAIStatus) return 'Conversational Time Based';
    if (interviewTypeObj.codingAndAptitude) return 'Coding & MCQ';
    if (interviewTypeObj.interviewType === 'psychometric_assessment') return 'Psychometric Assessment';
    return 'Non Conversational Time Based';
};

export const debounce = (fn, delay = 400) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
};

// `<input type="number">` still accepts "e", "E", "+", "-" and ".", and reports an empty value when the
// result is not a valid number - so a field showing "20+-" reaches the form as "" and trips the
// "please fill in the required field" error. Block those characters at the source. Spread onto any
// number input that must hold plain digits.
export const digitsOnlyInputProps = {
    onKeyDown: (e) => {
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        if (['e', 'E', '+', '-', '.'].includes(e.key)) e.preventDefault();
    },
    onPaste: (e) => {
        if (!/^\d*$/.test(e.clipboardData?.getData('text') ?? '')) e.preventDefault();
    },
};

export const stripQuestionPrefix = (content) => {
    if (!content) return content;
    const str = String(content);
    const leadingTags = str.match(/^(?:<[^>]+>\s*)*/i)?.[0] ?? '';
    const rest = str.slice(leadingTags.length);
    return leadingTags + rest.replace(/^Q\.?\s*\d+\.?\s*/i, '');
};
